// extracted by mini-css-extract-plugin
export default {"alert":"index_alert__LXzCC"};